import IntegerBase from './integer-base';

export default class Integer extends IntegerBase {}
